
import styles from "./PartSurveyItem.module.scss";
import { useState } from "react";

import checkicon from 'assets/icons/check.png'
import circleicon from 'assets/icons/circle.png'
import squareicon from 'assets/icons/square.png'
import checksquareicon from 'assets/icons/square_check.png'
import pieeeeechart from 'assets/icons/pieeeeechart.png'
import Notification from "utils/Notifications";

import { removeDefendant, moveDefendantUp, moveDefendantDown } from "service/SurveyService";
import { EditorState, convertFromRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";

const PartSurveyItem = ({ item, index, setRender, MassLength, ChangeRowOn }) => {

    const [notify, setNotify] = useState({
        isOpen: false,
        message: "",
        type: "",
    });



    const DraftContent = ({ draftData }) => {
        // Преобразуем данные из текста в объект
        let contentState;
        try {
            const parsedData = typeof draftData === "string" ? JSON.parse(draftData) : draftData;
            contentState = convertFromRaw(parsedData);
            
            if  (!parsedData?.blocks[0]?.text) {
                return null
            
            }
        } catch (error) {
            console.error("Ошибка обработки данных Draft.js:", error);
            return <p>Invalid content format</p>;
        }

        // Создаём состояние редактора для отображения
        const editorState = EditorState.createWithContent(contentState);

        return (
            <div st>
                <Editor editorState={editorState} readOnly toolbarHidden />
            </div>
        );
    };

    const removeRow = (id) => {
        try {
            removeDefendant(id);
            setNotify({
                isOpen: true,
                message: "Данные успешно отправлены!",
                type: "success",
            });
            setRender(true);
        } catch (error) {
            console.error("Ошибка отправки данных:", error);
            setNotify({
                isOpen: true,
                message: "Ошибка при отправке данных!",
                type: "error",
            });
        }
    };
    const moveRowUp = (id) => {
        try {
            moveDefendantUp(id);
            setNotify({
                isOpen: true,
                message: "Данные успешно отправлены!",
                type: "success",
            });
            setRender(true);
        } catch (error) {
            console.error("Ошибка отправки данных:", error);
            setNotify({
                isOpen: true,
                message: "Ошибка при отправке данных!",
                type: "error",
            });
        }

    };
    const moveRowDown = (id) => {
        try {
            moveDefendantDown(id);
            setNotify({
                isOpen: true,
                message: "Данные успешно отправлены!",
                type: "success",
            });
            setRender(true);
        } catch (error) {
            console.error("Ошибка отправки данных:", error);
            setNotify({
                isOpen: true,
                message: "Ошибка при отправке данных!",
                type: "error",
            });
        }
    };
    const [text, setText] = useState('');
    const maxLength = 1000;  // Максимальное количество символов

    const handleChange = (event) => {
        // Обновляем состояние с текстом
        setText(event.target.value);
    };

    const [file, setFile] = useState(null);

    const handleFileChange_test = (e) => {
        setFile(e.target.files[0]);
    };

    return (

        <div className={styles.defendant_card_selection}>
            <div className={styles.defendant_card_selection_header}>

                {item.type_defendant === 'singleSelection' && <h3>Одиночный выбор</h3>}
                {item.type_defendant === 'multipleSelection' && <h3>Множественный выбор</h3>}
                {item.type_defendant === 'numericInput' && <h3>Ввод числа</h3>}
                {item.type_defendant === 'textInput' && <h3>Ввод текста</h3>}
                {item.type_defendant === 'freeTextDefendant' && <h3>Ответ в свободной форме</h3>}
                {item.type_defendant === 'sequenceOrdering' && <h3>Установление последовательности</h3>}
                {item.type_defendant === 'slider' && <h3>Слайдер (ползунок)</h3>}
                {item.type_defendant === 'fileUpload' && <h3>Загрузка файла</h3>}
                {item.type_defendant === 'infoText' && <h3>Информационный текст</h3>}

              
            </div>
            {item.image &&
                <img
                    src={item.image}
                    className={styles.img_file}
                />
            }
            <div className={styles.defendant_card_selection_body}>

                <DraftContent draftData={item.body} />
                <div className={styles.defendant_card_selection_body_defendant}>
                    {item.defendant_part_survey.map((defendant, index) => (
                        <div style={{ width: '100%' }}>
                            {(item.type_defendant !== "freeTextDefendant" && item.type_defendant !== "infoText" && item.type_defendant !== 'fileUpload') ? (
                                <div className={styles.defendant_card_header}>

                                    {(item.checkpoints === true && item.type_defendant !== 'numericInput' && item.type_defendant !== 'textInput' && item.type_defendant !== "slider" && item.type_defendant !== 'sequenceOrdering') &&
                                        <img
                                            src={defendant.points > 0 ? checkicon : circleicon}
                                            className={styles.img}
                                        />
                                    }

                                    {(item.checkpoints === false && item.type_defendant !== 'numericInput' && item.type_defendant !== 'textInput' && item.type_defendant !== "slider" && item.type_defendant !== 'sequenceOrdering') &&
                                        <img
                                            src={defendant.right_defendant === true ? checksquareicon : squareicon}
                                            className={styles.img}
                                        />
                                    }
                                    {(item.type_defendant === 'sequenceOrdering') &&
                                        <>
                                            <DraftContent draftData={defendant.title} />
                                            <select
                                                className={styles.point_check_num_text}
                                                value={defendant.sequences_selectedNumber}  // привязываем к состоянию

                                            >
                                                <option value={defendant.sequences_selectedNumber}>{defendant.sequences_selectedNumber}</option>
                                            </select>
                                        </>
                                    }
                                    {(item.type_defendant === 'slider') &&
                                        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: "5px" }}>
                                            <div>
                                                <h4 >{defendant.type_input_txt}</h4>

                                            </div>
                                            <div className={styles.slider_min_max}>
                                                <h4>{Math.min(Number(defendant.min_len), Number(defendant.max_len))}</h4>
                                                <input
                                                    id="slider"
                                                    type="range"
                                                    min={Math.min(Number(defendant.min_len), Number(defendant.max_len))}
                                                    max={Math.max(Number(defendant.min_len), Number(defendant.max_len))}
                                                    value={defendant.rdefendant}
                                                    style={{ width: '100%' }}
                                                />
                                                <h4>{Math.max(Number(defendant.min_len), Number(defendant.max_len))}</h4>
                                                <h4 className={styles.slider_right_defendant}> <img
                                                    src={checksquareicon}
                                                    className={styles.img}
                                                />{defendant.rdefendant}</h4>
                                            </div>
                                        </div>
                                    }
                                    {(item.type_defendant === 'numericInput') &&
                                        <h4 style={{ border: '1px solid rgb(41, 33, 33)', padding: '5px 10px' }}>{defendant.type_input_int}</h4>
                                    }
                                    {(item.type_defendant === 'textInput') &&
                                        <h4 style={{ border: '1px solid rgb(123, 123, 123)', padding: '5px 10px' }}>{defendant.type_input_txt}</h4>
                                    }
                                    {(item.type_defendant === 'singleSelection' || item.type_defendant === 'multipleSelection') &&
                                        <DraftContent draftData={defendant.title} />
                                    }
                                </div>
                            ) : (
                                <>
                                    {item.type_defendant === "freeTextDefendant" && (
                                        <div className={styles.defendant_card_header}>
                                            <div className={styles.defendant_card_second_div} >
                                                <textarea
                                                    value={text}
                                                    className={styles.defendant_card_header_textarea}
                                                    onChange={handleChange}
                                                    maxLength={item.max_len}
                                                    rows="4"
                                                    cols="50"
                                                    placeholder="Тестовая печать"
                                                />
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'end' }}>
                                                    <span>{text.length} / {item.max_len}</span>
                                                </div>
                                            </div>
                                        </div>

                                    )}
                                    {item.type_defendant === "fileUpload" && (
                                        <div className={styles.defendant_card_header}>
                                            <div className={styles.defendant_card_second_div} >
                                                <input
                                                    type="file"
                                                    id="file-upload"
                                                    className={styles.file_upload_input}
                                                    onChange={handleFileChange_test}  // Исправлено: вызываем функцию
                                                />
                                                <label htmlFor="file-upload" className={styles.file_upload_label}>
                                                    {file ? file.name : 'Загрузите файл'}
                                                </label>
                                            </div>
                                        </div>
                                    )}

                                </>
                            )}
                            {defendant.file &&
                                <img
                                    src={defendant.file}
                                    className={styles.img_file}
                                />
                            }
                        </div>
                    ))}
                </div>
                {item?.comment !== null &&
                    <div style={{ marginTop: '40px', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                        

                        <DraftContent draftData={item.comment} />

                    </div>
                }

            </div>
            <div className={styles.defendant_card_selection_footer}>

                {item.part_number > 1 && (
                    <button
                        onClick={() => moveRowUp(item.id)}
                        style={{
                            padding: "10px 16px",
                            backgroundColor: "#27ae60",
                            color: "#fff",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "pointer",
                            fontWeight: "600",
                            fontSize: "14px",
                            fontFamily: "'Nunito', sans-serif",
                            transition: "all 0.2s ease"
                        }}
                    >
                        ↑
                    </button>
                )}
                {item.part_number < MassLength && (
                    <button
                        onClick={() => moveRowDown(item.id)}
                        style={{
                            padding: "10px 16px",
                            backgroundColor: "#f39c12",
                            color: "#fff",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "pointer",
                            fontWeight: "600",
                            fontSize: "14px",
                            fontFamily: "'Nunito', sans-serif",
                            transition: "all 0.2s ease"
                        }}
                    >
                        ↓
                    </button>
                )}

                <button
                    style={{
                        padding: "10px 16px",
                        fontSize: "14px",
                        color: "#fff",
                        border: "none",
                        background: "#3498db",
                        borderRadius: "6px",
                        cursor: "pointer",
                        fontWeight: "600",
                        fontFamily: "'Nunito', sans-serif",
                        transition: "all 0.2s ease"
                    }}
                    onClick={() => ChangeRowOn(item.id)}
                >
                    Редактировать
                </button>

                <button
                    onClick={() => removeRow(item.id)}
                    style={{
                        padding: "10px 16px",
                        backgroundColor: "#e74c3c",
                        color: "#fff",
                        border: "none",
                        borderRadius: "6px",
                        cursor: "pointer",
                        fontWeight: "600",
                        fontSize: "14px",
                        fontFamily: "'Nunito', sans-serif",
                        transition: "all 0.2s ease"
                    }}
                >
                    Удалить
                </button>
            </div>
            <hr></hr>
            <Notification notify={notify} setNotify={setNotify} />
        </div >





    );
};

export default PartSurveyItem;
